import { render, staticRenderFns } from "./SummerFestivalInventory.vue?vue&type=template&id=48a65bea&scoped=true"
import script from "./SummerFestivalInventory.vue?vue&type=script&lang=js"
export * from "./SummerFestivalInventory.vue?vue&type=script&lang=js"
import style0 from "./SummerFestivalInventory.vue?vue&type=style&index=0&id=48a65bea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a65bea",
  null
  
)

export default component.exports